import { memo } from "react";
import { Icon, Text, useTheme, type DivProps, type OmitProps } from "react-better-html";

import { useI18n } from "../../utils/i18n";

import DecorationCard from "./DecorationCard";

type DecorationPriceTrendCardProps = OmitProps<DivProps, "children"> & {};

function DecorationPriceTrendCard({ ...props }: DecorationPriceTrendCardProps) {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <DecorationCard whiteSpace="nowrap" {...props}>
         <Text fontSize={12} color={theme.colors.textSecondary}>
            {t((l) => l.components.decorations.priceTrend)}
         </Text>

         <Icon name="graphLineDecoration" size={120} height={30} color={theme.colors.primary} strokeWidth={2} />
      </DecorationCard>
   );
}

export default memo(DecorationPriceTrendCard);
